import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Intelligent Process Automation",
        description: "Automate repetitive tasks with AI-powered workflows, improving efficiency.",
        imgUrl: "./img/services/ai-automation/intelligent-process.jpg",
    },
    {
        title: "Chatbots and Virtual Assistants",
        description: "Enhance customer interactions with conversational AI solutions.",
        imgUrl: "./img/services/ai-automation/chatbots-and-virtual-assistants.png",
    },
    {
        title: "Predictive Maintenance",
        description: "Reduce downtime with AI-driven predictions for equipment and processes.",
        imgUrl: "./img/services/ai-automation/predictive-maintain.jpg",
    },
    {
        title: "Document Processing",
        description: "Extract and process data from documents with natural language understanding.",
        imgUrl: "./img/services/ai-automation/document-processing.jpg",
    },
    {
        title: "AI-Powered Decision Support",
        description: "Leverage AI to analyze data and support strategic decision-making.",
        imgUrl: "./img/services/ai-automation/ai-powered-decision-support.jpg",
    },
    {
        title: "Real-Time Monitoring",
        description: "Track and respond to changes in systems or processes instantly.",
        imgUrl: "./img/services/ai-automation/realtime-monitoring.jpg",
    },
];


const AIAutomation = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "AI Automation Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="AI Automation Solutions" description="Streamline your operations and achieve scalability with cutting-edge AI automation." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is AI Automation?</h2>
                            <p>
                                AI Automation leverages artificial intelligence to simplify, optimize, and automate complex business processes. From customer support to supply chain management, AI can transform your organization’s efficiency.
                            </p>
                            <img
                                src="./img/services/ai-automation.jpg"
                                alt="AI Automation Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of AI Automation</h2>
                            <ul>
                                <li>Increase productivity by automating time-consuming tasks.</li>
                                <li>Reduce operational costs with efficient AI-powered solutions.</li>
                                <li>Enhance customer satisfaction through personalized, responsive services.</li>
                                <li>Minimize errors with consistent and reliable AI systems.</li>
                                <li>Gain valuable insights and improve decision-making with real-time data.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Discover the Power of AI Automation</h2>
                            <p>
                                Revolutionize your business with AI automation. Contact us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default AIAutomation;
